/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
import * as i0 from "@angular/core";
import * as i1 from "@angular/router";
import * as i2 from "./buildings-router.component";
var styles_BuildingsRouterComponent = [];
var RenderType_BuildingsRouterComponent = i0.ɵcrt({ encapsulation: 2, styles: styles_BuildingsRouterComponent, data: {} });
export { RenderType_BuildingsRouterComponent as RenderType_BuildingsRouterComponent };
export function View_BuildingsRouterComponent_0(_l) { return i0.ɵvid(0, [(_l()(), i0.ɵeld(0, 16777216, null, null, 1, "router-outlet", [], null, null, null, null, null)), i0.ɵdid(1, 212992, null, 0, i1.RouterOutlet, [i1.ChildrenOutletContexts, i0.ViewContainerRef, i0.ComponentFactoryResolver, [8, null], i0.ChangeDetectorRef], null, null)], function (_ck, _v) { _ck(_v, 1, 0); }, null); }
export function View_BuildingsRouterComponent_Host_0(_l) { return i0.ɵvid(0, [(_l()(), i0.ɵeld(0, 0, null, null, 1, "app-buildings-router", [], null, null, null, View_BuildingsRouterComponent_0, RenderType_BuildingsRouterComponent)), i0.ɵdid(1, 49152, null, 0, i2.BuildingsRouterComponent, [], null, null)], null, null); }
var BuildingsRouterComponentNgFactory = i0.ɵccf("app-buildings-router", i2.BuildingsRouterComponent, View_BuildingsRouterComponent_Host_0, {}, {}, []);
export { BuildingsRouterComponentNgFactory as BuildingsRouterComponentNgFactory };



// WEBPACK FOOTER //
// ./src/app/buildings/buildings-router.component.ngfactory.js.pre-build-optimizer.js